import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import accountsReducer from "./accounts/accountsSlice";
import executionLogReducer from "./execution-log/executionLogSlice";
import accountSetupReducer from "./account-setup/accountSetupSlice";
import filtersReducer from "./filters/filtersSlice";
import { rtkQueryErrorLoggerMiddleware } from "./middlewares/rtkQueryErrorLoggerMiddleware";
import { unauthenticatedMiddleware } from "./middlewares/unauthenticatedMiddleware";
import schedulesReducer from "./schedules/schedulesSlice";
import cloudChatSlice from "./cloudchat/cloudChatSlice";
import commitmentsSlice from "./commitments/commitmentsSlice";
import accountSlice from "./account/accountSlice";
import resourceExplorerSlice from "./resource-explorer/resourceExplorerSlice";
import cleanReducer from "./clean/cleanSlice";
import integrationsReducer from "./integrations/integrationsSlice";
import commonReducer from "./common/commonSlice";
import budgetsSlice from "./budgets/budgetsSlice";
import dashboardsSlice from "./dashboards/dashboardsSlice";
import dimensionsSlice from "./dimensions/dimensionsSlice";
import recommendationsSlice from "./recommendations/recommendationsSlice";
import navigationSlice from "./navigation/navigationSlice";
import { cloudChiprApi } from "../services/cloudchipr.api";

export const store = configureStore({
  reducer: {
    // keep alphanumeric sorting
    account: accountSlice,
    accountSetup: accountSetupReducer,
    accounts: accountsReducer,
    auth: authReducer,
    budgets: budgetsSlice,
    clean: cleanReducer,
    cloudchat: cloudChatSlice,
    commitments: commitmentsSlice,
    common: commonReducer,
    dashboards: dashboardsSlice,
    dimensions: dimensionsSlice,
    executionLog: executionLogReducer,
    filters: filtersReducer,
    integrations: integrationsReducer,
    recommendations: recommendationsSlice,
    resourceExplorer: resourceExplorerSlice,
    schedules: schedulesReducer,
    navigation: navigationSlice,
    [cloudChiprApi.reducerPath]: cloudChiprApi.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware()
      .concat(cloudChiprApi.middleware)
      .concat(rtkQueryErrorLoggerMiddleware)
      .concat(unauthenticatedMiddleware);
  },
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
